//company-viewchart start //

import ConfigDB from '../../../Config/ThemeConfig';

const primary = ConfigDB.color.primary_color;
const secondary = ConfigDB.color.secondary_color;

export const companyViewChart = {
  series: [
    {
      name: 'This Month ',
      data: [150, 170, 230, 190, 200, 110, 300, 110, 220, 130, 110],
    },
    {
      name: 'This Month',
      data: [150, 230, 200, 160, 230, 240, 160, 260, 280, 120, 110],
    },
  ],
  options: {
    chart: {
      height: 223,
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [4, 3],
      curve: 'smooth',
      dashArray: [0, 8],
    },
    colors: [primary, secondary],
    markers: {
      size: 0,
      colors: ['#fff'],
      strokeWidth: 0,
    },
    xaxis: {
      categories: ['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      {
        labels: {
          formatter: function (value) {
            return value + 'k';
          },
        },
        max: 300,
        min: 100,
        tickAmount: 2,
      },
    ],
    grid: {
      borderColor: '#f1f1f1',
    },
    responsive: [
      {
        breakpoint: 1470,
        options: {
          xaxis: {
            offsetY: 20,
          },
        },
      },
      {
        breakpoint: 1366,
        options: {
          chart: {
            height: 223,
          },
        },
      },
      {
        breakpoint: 1200,
        options: {
          chart: {
            height: 215,
          },
        },
      },
      {
        breakpoint: 1007,
        options: {
          chart: {
            height: 240,
          },
        },
      },
      {
        breakpoint: 887,
        options: {
          chart: {
            height: 215,
          },
        },
      },
    ],
  },
};

// sell view chart //
export const saleViewChartOption = {
  series: [
    {
      name: 'Selling',
      data: [25, 70, 50, 70, 55, 25, 40, 50],
    },
    {
      name: 'Selling',
      data: [-30, -15, -40, -70, -50, -60, -25, -70],
    },
  ],
  options: {
    chart: {
      type: 'bar',
      height: 370,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    colors: [primary, secondary],
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '20%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    stroke: {
      curve: 'smooth',
    },
    grid: {
      show: true,
      borderColor: '#f0f0f0',
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    xaxis: {
      min: -99,
      max: 99,
      tickAmount: 8,
      labels: {
        formatter: function (val) {
          return Math.abs(Math.round(val)) + 'k';
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 1741,
        options: {
          chart: {
            height: 275,
          },
        },
      },
      {
        breakpoint: 1661,
        options: {
          chart: {
            height: 263,
          },
        },
      },
      {
        breakpoint: 1551,
        options: {
          chart: {
            height: 260,
          },
        },
      },

      {
        breakpoint: 1200,
        options: {
          chart: {
            height: 280,
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 220,
          },
        },
      },
    ],
  },
};

// profit chart start
export const ProfitOverviewOption = {
  series: [
    {
      name: 'This Month Profit',
      data: [60, 60, 20, 5, 70, 70, 85, 80],
    },
    {
      name: 'This Month Profit',
      data: [100, 100, 0, 0, 0, 0, 0, 100],
    },
    {
      name: 'This Month Profit',
      data: [0, 0, 0, 100, 100, 100, 0, 0],
    },
  ],
  options: {
    chart: {
      height: 370,
      type: 'radar',
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: 0,
      curve: 'smooth',
    },
    legend: {
      show: false,
    },
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    grid: {
      borderColor: '#d3dbf4',
    },
    colors: [primary],
    markers: {
      size: [4, 0, 0],
      colors: '#fff',
      strokeColor: primary,
      strokeWidth: 3,
    },
    yaxis: {
      tickAmount: 6,
      show: false,
    },
    responsive: [
      {
        breakpoint: 1741,
        options: {
          chart: {
            height: 300,
          },
        },
      },
      {
        breakpoint: 1661,
        options: {
          chart: {
            height: 280,
          },
        },
      },
      {
        breakpoint: 1366,
        options: {
          chart: {
            height: 245,
          },
          xaxis: {
            offsetX: -10,
          },
        },
      },
      {
        breakpoint: 992,
        options: {
          chart: {
            height: 300,
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 300,
          },
        },
      },
      {
        breakpoint: 421,
        options: {
          chart: {
            height: 270,
          },
        },
      },
    ],
  },
};
